import { createSlice } from "@reduxjs/toolkit";
import * as actions from "../action/wallet";
import {
  allWalletBalanceResponse,
  bonusSummaryResponse,
  bonusTransactionHistoryResponse,
  transactionHistoryResponse,
  withdrawHistoryResponse,
} from "../../types/wallet";
import Toast from "../../helpers/Toast";
import { getBonusTransactionHistory, withdrawalWallet } from "../action/wallet";

type InitialState = {
  walletBalanceList: allWalletBalanceResponse[];
  bonusSummaryList: bonusSummaryResponse[];
  walletBalance: number;
  transactionHistory: transactionHistoryResponse[];
  count: number;
  withdrawHistory: withdrawHistoryResponse[];
  bonusTransactionHistory: bonusTransactionHistoryResponse[];
};

const initialState: InitialState = {
  walletBalanceList: [],
  bonusSummaryList: [],
  walletBalance: 0,
  transactionHistory: [],
  count: 0,
  withdrawHistory: [],
  bonusTransactionHistory: [],
};

const walletSlices = createSlice({
  name: "wallet",
  initialState: initialState,
  reducers: {
    resetWallet: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(actions.getWalletBalanceList.fulfilled, (state, action) => {
        state.walletBalanceList = action.payload;
      })
      .addCase(actions.getWalletBalanceList.rejected, (state, action) => {
        state.walletBalanceList = [];
        // Toast.fire({
        //   icon: "error",
        //   title: "Fail to Get Balance List",
        // });
      })

      .addCase(actions.getBonusSummaryList.fulfilled, (state, action) => {
        state.bonusSummaryList = action.payload;
      })
      .addCase(actions.getBonusSummaryList.rejected, (state, action) => {
        state.bonusSummaryList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Bonus Summary List",
        });
      })

      .addCase(actions.getWalletBalance.fulfilled, (state, action) => {
        state.walletBalance = action.payload;
      })
      .addCase(actions.getWalletBalance.rejected, (state, action) => {
        state.walletBalance = 0;
        Toast.fire({
          icon: "error",
          title: "Fail to Get Wallet Balance",
        });
      })

      .addCase(actions.getTransactionHistory.fulfilled, (state, action) => {
        state.transactionHistory = action.payload;
        state.count = action.payload.length;
      })
      .addCase(actions.getTransactionHistory.rejected, (state, action) => {
        state.transactionHistory = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Transaction History",
        });
      })

      .addCase(actions.getWithdrawHistory.fulfilled, (state, action) => {
        state.withdrawHistory = action.payload;
        state.count = action.payload.length;
      })
      .addCase(actions.getWithdrawHistory.rejected, (state, action) => {
        state.withdrawHistory = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Transaction History",
        });
      })

      .addCase(
        actions.getBonusTransactionHistory.fulfilled,
        (state, action) => {
          state.bonusTransactionHistory = action.payload;
          state.count = action.payload.length;
        },
      )
      .addCase(actions.getBonusTransactionHistory.rejected, (state, action) => {
        state.withdrawHistory = [];
      })

      .addCase(actions.covertWallet.fulfilled, (state, action) => {
        console.log(action.payload);
        // @ts-ignore
        if (action.payload.data?.status === true) {
          Toast.fire({
            icon: "success",
            title: "Success Convert",
          });
        } else {
          Toast.fire({
            icon: "error",
            // @ts-ignore
            title: action?.payload?.data?.msg,
          });
        }
      })
      .addCase(actions.covertWallet.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Failed Convert",
        });
      })

      .addCase(actions.withdrawalWallet.fulfilled, (state, action) => {
        // @ts-ignore
        if (action.payload.data.status === true) {
          Toast.fire({
            icon: "success",
            title: "Success Withdrawal",
          });
        } else {
          Toast.fire({
            icon: "error",
            // @ts-ignore
            title: action?.payload?.data.msg,
          });
        }
      })
      .addCase(actions.withdrawalWallet.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Failed Withdrawal",
        });
      })
      .addCase(actions.transferWallet.fulfilled, (state, action) => {
        // @ts-ignore
        if (action.payload.data.status === true) {
          Toast.fire({
            icon: "success",
            title: "Success Transfer",
          });
        } else {
          Toast.fire({
            icon: "error",
            // @ts-ignore
            title: action?.payload?.data.msg,
          });
        }
      })
      .addCase(actions.transferWallet.rejected, (state, action) => {
        // @ts-ignore
        if (action.payload.data.status == false) {
          Toast.fire({
            icon: "error",
            // @ts-ignore
            title: action?.payload?.data.msg,
          });
        }
      });
  },
});

export const {} = walletSlices.actions;
export default walletSlices.reducer;
